module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1046-5956003089068dc3e56b827916d5a587.png";